export function SearchPage() {
  const searchForm = document.querySelector("form#search-form");
  console.log("Form found:", searchForm);

  if (!searchForm) return console.warn("No form found!");

  const inputs = searchForm.querySelectorAll("input");
  console.log("Inputs found:", inputs.length);

  inputs.forEach((el) => {
    el.addEventListener("change", () => {
      console.log("Changed input:", el.name, "=", el.value);
      searchForm.submit();
      console.log("Form submitted");
    });
  });
}
